import React from "react";
import { Navigate } from "react-router-dom";
import { useOwnerAccess } from "../hooks/useOwnerAccess";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import NotFoundPage from "../pages/NotFound";

interface OwnerProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

/**
 * Protected route that checks:
 * - User is logged in
 * - User is the company owner (isOwner: true)
 */
const OwnerProtectedRoute: React.FC<OwnerProtectedRouteProps> = ({ children, isLoggedIn }) => {
    const { hasAccess, loading } = useOwnerAccess();

    if (loading) {
        return <LoadingSpinner size={50} />;
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (!hasAccess) {
        return <NotFoundPage />;
    }

    return children;
};

export default OwnerProtectedRoute;
